import styled, { keyframes } from 'styled-components'
import Logo from './../../app/assets/images/ic_logo_red.svg'

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const MaintenanceContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ac0000, #f5f5f5);
  color: #fff;
  height: 100vh;
`

const Container = styled.div`
  text-align: center;
  padding: 2rem;
`

const Heading = styled.h1`
  font-size: 3rem;
  margin-bottom: 1rem;
`

const Paragraph = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
`

const Spinner = styled.div`
  border: 8px solid rgba(255, 255, 255, 0.3);
  border-top: 8px solid #fff;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: ${spin} 1s linear infinite;
  margin: 0 auto;
`

const LogoImage = styled.img`
  width: 100px;
  height: auto;
  margin-bottom: 30px;
`

const Maintenance = () => (
  <MaintenanceContainer>
    <Container>
      <LogoImage src={Logo} alt="Target Logo" />
      <Heading>We'll be back soon!</Heading>
      <Paragraph>
        Our website is currently undergoing scheduled maintenance.
      </Paragraph>
      <Spinner />
    </Container>
  </MaintenanceContainer>
)

export default Maintenance
